import ContainerView from "./../view/container.js";
import PinView from "./../view/pin.js";
import PinModel from "./../model/pin.js";

import {
  DefaultModel,
  Action,
  TIMEOUT_TIME
} from "./../const.js";

export default class ImagesPinsPresenter {
  constructor(container) {
    this._container = container;

    this._containerView = new ContainerView(container);
    this._pinsViews = [];
    this._pinsModels = [];

    this._handleElementMouseenter = this._handleElementMouseenter.bind(this);
    this._handleElementMouseleave = this._handleElementMouseleave.bind(this);
    this._handleElementClick = this._handleElementClick.bind(this);
    this._handleChangeModel = this._handleChangeModel.bind(this);
  }

  init() {
    this._setItems();

    this._pinsViews.forEach((component) => {
      component.setElementMouseenterHandler(this._handleElementMouseenter);
      component.setElementMouseleaveHandler(this._handleElementMouseleave);
      component.setElementClickHandler(this._handleElementClick);
    });
    this._pinsModels.forEach((component) => component.addObserver(this._handleChangeModel));
  }

  _setItems() {
    Array.from(this._containerView.getElement().children)
      .forEach((pin, index) => {
        this._pinsViews.push(new PinView(pin, index));

        const pinModel = Object.assign(
            {},
            DefaultModel
        );

        this._pinsModels.push(new PinModel(pinModel, index));
      });
  }

  _handleChangeModel(action, {id}) {
    switch (action) {
      case Action.OPEN:
        this._pinsViews[id].open();
        break;
      case Action.CLOSE:
        this._pinsViews[id].close();
        break;
    }
  }

  _handleElementMouseenter(id) {
    const currentModel = this._pinsModels[id];
    let modelData = currentModel.getData();

    if (modelData.isOpen === true) {
      return;
    }

    currentModel.changeData(Object.assign(
        {},
        modelData,
        {
          isOpen: true,
          isMouseenter: true
        }
    ), Action.OPEN);

    setTimeout(() => {
      modelData = currentModel.getData();

      currentModel.changeData(Object.assign(
          {},
          modelData,
          {
            isMouseenter: false
          }
      ));
    }, TIMEOUT_TIME);
  }

  _handleElementMouseleave(id) {
    const currentModel = this._pinsModels[id];
    const modelData = currentModel.getData();

    if (modelData.isOpen === false) {
      return;
    }

    currentModel.changeData(Object.assign(
        {},
        modelData,
        {
          isOpen: false,
        }
    ), Action.CLOSE);
  }

  _handleElementClick(id) {
    const currentModel = this._pinsModels[id];
    const modelData = currentModel.getData();

    if (modelData.isMouseenter === true) {
      return;
    }

    let action;

    switch (modelData.isOpen) {
      case true:
        action = Action.CLOSE;
        break;
      case false:
        action = Action.OPEN;
        break;
    }

    currentModel.changeData(Object.assign(
        {},
        modelData,
        {
          isOpen: !modelData.isOpen,
          isMouseenter: false
        }
    ), action);
  }
}
